"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Translate_1 = __importDefault(require("../../base/Translate"));

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var ActiveRatingBox_1 = __importDefault(require("./styledComponents/ActiveRatingBox"));

var BottomLabels_1 = __importDefault(require("./styledComponents/BottomLabels"));

var Label_1 = __importDefault(require("./styledComponents/Label"));

var LeftLabel_1 = __importDefault(require("./styledComponents/LeftLabel"));

var Ratings_1 = __importDefault(require("./styledComponents/Ratings"));

var RatingBox_1 = __importDefault(require("./styledComponents/RatingBox"));

var RightLabel_1 = __importDefault(require("./styledComponents/RightLabel"));

var TopLabels_1 = __importDefault(require("./styledComponents/TopLabels"));

var RiskRating_meta_1 = require("./RiskRating.meta");

var RiskRating =
/** @class */
function (_super) {
  __extends(RiskRating, _super);

  function RiskRating(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = RiskRating_meta_1.RISK_RATING_CATEGORY_KEY;
    _this.componentKey = RiskRating_meta_1.RISK_RATING_COMPONENT_KEY;

    _this.renderTopLabels = function () {
      var labels = _this.props.labels;

      if (labels && labels.top) {
        return react_1.default.createElement(TopLabels_1.default, {
          "aria-hidden": true
        }, _this.renderLabelsChildren(labels.top));
      }

      return null;
    };

    _this.renderBottomLabels = function () {
      var labels = _this.props.labels;

      if (labels && labels.bottom) {
        return react_1.default.createElement(BottomLabels_1.default, {
          "aria-hidden": true
        }, _this.renderLabelsChildren(labels.bottom));
      }

      return null;
    };

    _this.renderLabelsChildren = function (labels) {
      var left = labels.left,
          right = labels.right;
      return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(LeftLabel_1.default, null, react_1.default.createElement(Label_1.default, null, react_1.default.createElement(Translate_1.default, null, left || ''))), react_1.default.createElement(RightLabel_1.default, null, react_1.default.createElement(Label_1.default, null, react_1.default.createElement(Translate_1.default, null, right || ''))));
    };

    return _this;
  }

  RiskRating.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        _b = _a.count,
        count = _b === void 0 ? 7 : _b,
        value = _a.value;
    var ratings = Array(count).fill('');
    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      role: "text",
      "aria-label": "" + value
    }, this.renderTopLabels(), react_1.default.createElement(Ratings_1.default, {
      "aria-hidden": true
    }, ratings.map(function (element, index) {
      var rating = index + 1;
      var isActive = value === rating;
      var Box = isActive ? ActiveRatingBox_1.default : RatingBox_1.default;
      return react_1.default.createElement(Box, {
        key: rating
      }, rating);
    })), this.renderBottomLabels());
  };

  RiskRating.defaultProps = {
    count: 7,
    value: 0
  };
  RiskRating = __decorate([mobx_react_1.observer], RiskRating);
  return RiskRating;
}(shared_1.ComponentBase);

exports.RiskRating = RiskRating;
exports.default = shared_1.InjectedStyledComponent(RiskRating, RiskRating_meta_1.RISK_RATING_CATEGORY_KEY, RiskRating_meta_1.RISK_RATING_COMPONENT_KEY);